module.exports = __webpack_public_path__ + "img/ca117fb.jpg";